// check if provided domain is in blocked list
const blockedDomains = new Set([
  "mailinator.com",
  "guerrillamail.com",
  "yopmail.com",
  "10minutemail.com",
  "mytrashmail.com",
  "mailexpire.com",
  "pookmail.com",
  "dodgeit.com",
  "fakeinbox.com",
  "spamgourmet.com",
  "spambox.us",
  "tempmailo.com",
  "emailondeck.com",
  "fakemail.net",
  "tempail.com",
  "generator.email",
  "emailnator.com",
  "mohmal.com",
  "temp-mail.io",
  "email-fake.com",
  "disposablemail.com",
  "tempmail.dev",
  "emailfake.com",
  "temp-mail.org",
  "fakemailgenerator.com",
  "internxt.com",
  "onlinewebtoolkit.com",
  "mailmodo.com",
  "one.com",
  "shubham.co",
  "maildrop.cc",
  "mail2world.com",
  "tutanota.com",
  "skimlinks.com",
  "adams.net",
  "edu.com",
]);

export function checkIsBlockedDomain(value) {
  const domain = value.split("@")[1];
  return domain ? blockedDomains.has(domain) : false;
}

// check if valid email according to provided RegExp
export function checkIsValidEmail(value) {
  const regExpEmail =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return new RegExp(regExpEmail).test(value);
}

// check if selected any radios of current slide in case if it's required
export function checkRadiosSelection(radiosWrapper) {
  let formRadios = radiosWrapper.querySelectorAll('input[type="radio"]');
  let isCheckedRadio = false;

  for (const input of formRadios) {
    if (input.checked) {
      isCheckedRadio = true;
      break;
    }
  }

  return isCheckedRadio;
}

export function checkMinMaxLength(input) {
  const value = input.value.trim();
  const valueLength = value.length;
  const isRequired = input.required;
  const minLength = input.minLength; // -1 when attribute not set
  const maxLength = input.maxLength; // -1 when attribute not set

  if (!isRequired && valueLength === 0) return true;
  if (isRequired && valueLength === 0) return false;
  if (minLength > 0 && valueLength < minLength) return false;
  if (maxLength > 0 && valueLength > maxLength) return false;

  return true;
}
